module.exports.loadContext = function loadContext(context) { context.keys().map(context) }
